import script from "./AppAlerts.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAlerts.vue?vue&type=script&setup=true&lang=ts"

import "./AppAlerts.vue?vue&type=style&index=0&id=561f0d25&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-561f0d25"]])

export default __exports__